/**
 * Created by Rodrigo Quesada on 04/12/16.
 */
import {Router} from '@angular/router';
import {SectionsService} from '../../../components/sections/service/sections.service';
import {rootRoutePath as dashboardPath} from '../../dashboard/dashboard-page.routing';
import {PageStateService} from '../services/page-state.service';
import {NavigationService} from '../../../navigation/service/navigation.service';
import {Observable} from 'rxjs/Observable';

export abstract class StepScreen {

    get stepNumber(): number {
        return this.sectionsService.currentSectionStepNumber;
    }

    get stepsProgress(): number {
        return this.sectionsService.currentSectionStepsProgress;
    }

    get title(): string {
        return this.sectionsService.currentSectionTitle;
    }

    abstract readonly router: Router;
    abstract readonly sectionsService: SectionsService;
    abstract readonly pageStateService: PageStateService;
    abstract readonly navigationService: NavigationService;

    hasPreviousScreen(): boolean {
        return this.sectionsService.hasPreviousScreen();
    }

    goToPreviousScreen() {
        if (!this.pageStateService.unsavedDataPresent() || this.navigationService.confirmUnsavedDataDiscarding()) {
            this.sectionsService.refreshed$.filter(value => value).first().subscribe(() => {
                this.sectionsService.goToPreviousScreen().subscribe();
            });
        }
    }

    hasNextScreen(): boolean {
        return true;
    }

    goToNextScreen$(): Observable<boolean> {
        return this.sectionsService.refreshed$.filter(value => value).first().switchMap(() => {
            if (this.sectionsService.hasNextScreen()) return this.sectionsService.goToNextScreen();
            else return this.router.navigate([dashboardPath]);
        }).map(_ => true);
    }

    goToNextScreen(): void {
        this.goToNextScreen$().subscribe();
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/shared/step/step-screen.class.ts